import { render, staticRenderFns } from "./pile-swap-record-table.vue?vue&type=template&id=0f1891e5&scoped=true"
import script from "./pile-swap-record-table.vue?vue&type=script&lang=js"
export * from "./pile-swap-record-table.vue?vue&type=script&lang=js"
import style0 from "./pile-swap-record-table.vue?vue&type=style&index=0&id=0f1891e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1891e5",
  null
  
)

export default component.exports